const isDeployedToProductionEndpoint = window.location.hostname === 'cashassist.hssoft.com'

const amplifyConfig = {
	Auth: {
		// REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
		identityPoolId: process.env.REACT_APP_IDENTITYPOOL_ID,

		// REQUIRED - Amazon Cognito Region
		region: process.env.REACT_APP_AWS_REGION,

		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: process.env.REACT_APP_USERPOOL_ID,

		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
		userPoolWebClientId: process.env.REACT_APP_USERPOOL_CLIENTID,

		// storage: amplifyStorage,

		cookieStorage: {
			// REQUIRED - Cookie domain (only required if cookieStorage is provided)
			domain: isDeployedToProductionEndpoint ? '.hssoft.com' : window.location.hostname,
			// OPTIONAL - Cookie path
			// path: '/',
			// OPTIONAL - Cookie expiration in days
			// expires: 365,
			// OPTIONAL - Cookie secure flag
			// Either true or false, indicating if the cookie transmission requires a secure protocol (https).
			secure: isDeployedToProductionEndpoint
		}

		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		// authenticationFlowType: 'USER_PASSWORD_AUTH'
	},
	Storage: {
		bucket: process.env.REACT_APP_S3_BUCKET, //REQUIRED -  Amazon S3 bucket
		region: process.env.REACT_APP_AWS_REGION //OPTIONAL -  Amazon service region
	},
	Analytics: {
		disabled: true
	}
}

export default amplifyConfig
